import { joinAndProvisionMatrixRTC, leaveMatrixRTCOnPageHide, } from './matrixRtcCallLifecycle.js';
export const createCallSessionHandles = () => ({ joinStarted: false });
/**
 * MSC4143 requires MatrixRTC encryption in an encrypted room and forbids it
 * otherwise, so nothing but the room's encryption state may decide this.
 */
export const callEncryptsMedia = (room) => room.hasEncryptionStateEvent();
/** Joining a running call must not ring again: whoever started it already did. */
export const isCallOngoing = (mx, room) => mx.matrixRTC.getRoomSession(room).memberships.length > 0;
/**
 * Join MatrixRTC and provision an SFU token, recording what the join installed
 * in `handles`. Both engines run this identically.
 */
export const joinCallSession = ({ dm, ongoing, encryptMedia, ...join }, handles) => joinAndProvisionMatrixRTC({
    ...join,
    ...(ongoing ? {} : { notificationType: dm ? 'ring' : 'notification' }),
    manageMediaKeys: encryptMedia,
    onMembershipWait: (cancel) => {
        handles.cancelMembershipWait = cancel;
    },
    onCallRoomSubscribed: (unsubscribe) => {
        handles.unsubscribeCallRoom = unsubscribe;
    },
    onJoinStarted: () => {
        handles.joinStarted = true;
        handles.removePageHideListener = leaveMatrixRTCOnPageHide(join.session);
    },
});
//# sourceMappingURL=callSession.js.map